import { Alert, Box, Button, CircularProgress, Stack, Typography } from '@mui/material';

export function LoadingState({ label = 'Loading' }: { label?: string }): React.JSX.Element {
  return (
    <Stack role="status" spacing={2} sx={{ alignItems: 'center', py: 8 }}>
      <CircularProgress size={32} />
      <Typography color="text.secondary">{label}…</Typography>
    </Stack>
  );
}

export function ErrorState({
  error,
  retry,
}: {
  error: unknown;
  retry?: () => void;
}): React.JSX.Element {
  return (
    <Alert severity="error" action={retry ? <Button onClick={retry}>Try again</Button> : undefined}>
      {error instanceof Error ? error.message : 'Something went wrong.'}
    </Alert>
  );
}

export function EmptyState({
  title,
  detail,
}: {
  title: string;
  detail: string;
}): React.JSX.Element {
  return (
    <Box sx={{ py: 7, textAlign: 'center' }}>
      <Typography variant="h2">{title}</Typography>
      <Typography color="text.secondary" sx={{ mt: 1 }}>
        {detail}
      </Typography>
    </Box>
  );
}
